export const QA_NAME_CHAT_CREATION_MODAL = 'create_chat'
